import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

const LegacyToolBanner = () => (
  <div className="bg-zinc-100 border border-zinc-300 px-4 py-3 flex items-center gap-3 text-xs font-mono">
    <AlertTriangle className="w-4 h-4 text-zinc-500 flex-shrink-0" />
    <span className="text-zinc-600">
      This is a legacy tool retained for reference. Visit the{' '}
      <Link to="/products" className="underline text-black hover:text-[#3832e3]">
        Platform
      </Link>{' '}
      page for current capabilities.
    </span>
  </div>
);

export default LegacyToolBanner;
